import PTTechnology from './news-pt-technology'
import PTEntertainment from './news-pt-entertainment'
import PTHealth from './news-pt-health'
import PTScience from './news-pt-science'
import PTSports from './news-pt-sports'

const PTCategories = {
    technology: PTTechnology,
    entertainment: PTEntertainment,
    health: PTHealth,
    science: PTScience,
    sports: PTSports
}

export default PTCategories;
